import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FlowProvider } from 'context/FlowContext';
import FlowLayout from 'components/storefront/FlowLayout';
import QuizPage from 'pages/QuizPage';
import QuizResultsPage from 'pages/QuizResultsPage';
import MenuPage from 'pages/MenuPage';
import SubscriptionBuilderPage from 'pages/SubscriptionBuilderPage';
import SubscriptionConfirmationPage from 'pages/SubscriptionConfirmationPage';
import CheckoutPage from 'pages/CheckoutPage';
import ConfirmationPage from 'pages/ConfirmationPage';
import MealPlanViewer from 'pages/MealPlanViewer';
import AuthTokenBridge from 'components/auth/AuthTokenBridge';
import PublicLayout from 'components/marketing/PublicLayout';
import HomePage from 'pages/HomePage';
import AboutPage from 'pages/AboutPage';
import ExpertsPage from 'pages/ExpertsPage';
import ExpertProfilePage, { ExpertArticlePage } from 'pages/ExpertProfilePage';
import FaqsPage from 'pages/FaqsPage';
import ContentPage from 'pages/ContentPage';
import AdminPage from 'pages/AdminPage';
import NotFoundPage from 'pages/NotFoundPage';
import ScrollToTop from 'components/shared/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      {/* Wires the Auth0 token into axios for all API calls */}
      <AuthTokenBridge />
      {/* Every navigation starts at the top of the page (Claire, Aug 2026) */}
      <ScrollToTop />
      <FlowProvider>
        <Routes>

          {/* Public storefront (new-landing-page) */}
          <Route element={<FlowLayout />}>
            <Route path="/quiz/results" element={<QuizResultsPage />} />
            <Route path="/this-weeks-menu" element={<MenuPage />} />
            <Route path="/menu" element={<MenuPage />} />
            {/* Wireframe only — not linked anywhere yet, for testing the
                subscription redesign before wiring real data/backend. */}
            <Route path="/subscription-wireframe" element={<SubscriptionBuilderPage />} />
            <Route path="/subscribe/confirmation" element={<SubscriptionConfirmationPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/confirmation" element={<ConfirmationPage />} />
          </Route>

          {/* Marketing + login pages (auth branch) — shared nav/footer */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/quiz" element={<QuizPage />} />
            <Route path="/login" element={<HomePage />} />
            <Route path="/callback" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            {/* Experts directory + one page per RD, both fed by /api/partners
                (SFLANDING-120). /experts-preview stays as an alias from when
                the directory was hidden. */}
            <Route path="/experts" element={<ExpertsPage />} />
            <Route path="/experts-preview" element={<ExpertsPage />} />
            <Route path="/experts/:slug" element={<ExpertProfilePage />} />
            <Route path="/experts/:slug/article" element={<ExpertArticlePage />} />
            {/* FAQs come from Airtable (FAQs table) with content/pages/faqs.js
                as the fallback — ahead of the /:slug catch-all on purpose. */}
            <Route path="/faqs" element={<FaqsPage />} />
            {/* Meal-plan dashboard lives INSIDE the site chrome (nav + footer) so
                customers can navigate anywhere and sign out via ACCOUNT. The page
                shows its own sign-in prompt when signed out. */}
            <Route path="/meal-plan" element={<MealPlanViewer />} />
            {/* Ported legacy pages (FAQs, contact forms, GLP-1, catering, specialty
                pages, etc.) — content modules in src/content/pages, one dynamic route.
                Static routes above always win over this catch-all slug. */}
            <Route path="/:slug" element={<ContentPage />} />
          </Route>

          {/* Team-only weekly menu portal — not linked from any nav */}
          <Route path="/admin" element={<AdminPage />} />

          {/* Unknown routes → home */}
          {/* Unknown paths render a 404 inside the marketing chrome rather than
              silently showing the homepage — see infra/nginx for the legacy redirects. */}
          <Route element={<PublicLayout />}>
            <Route path="*" element={<NotFoundPage />} />
          </Route>

        </Routes>
      </FlowProvider>
    </BrowserRouter>
  );
}

export default App;
